// ANCLA — scripts globales del tema (un solo archivo, cargado en layout/theme.liquid)
document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initGalerias();
  initComparadores();
  initFaqs();
  initFormulariosProducto();
  initHeaderOverlay();
});

function initHeaderOverlay() {
  var overlay = document.querySelector('.an-header-overlay');
  if (!overlay) return;
  function actualizar() {
    if (window.scrollY > 60) {
      if (!document.body.classList.contains('an-scrolled')) {
        document.body.style.paddingTop = overlay.getBoundingClientRect().height + 'px';
      }
      document.body.classList.add('an-scrolled');
    } else {
      document.body.classList.remove('an-scrolled');
      document.body.style.paddingTop = '';
    }
  }
  actualizar();
  window.addEventListener('scroll', actualizar, { passive: true });
  window.addEventListener('resize', actualizar);
}

function initReveals() {
  var els = document.querySelectorAll('.an-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('an-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = el.getAttribute('data-an-delay');
        if (delay) el.style.transitionDelay = delay + 'ms';
        el.classList.add('an-visible');
        obs.unobserve(el);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initGalerias() {
  document.querySelectorAll('[data-an-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-an-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-an-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-full');
        if (!full) return;
        principal.style.opacity = '0';
        window.setTimeout(function () {
          principal.src = full;
          principal.style.opacity = '1';
        }, 150);
        minis.forEach(function (m) { m.classList.remove('an-mini--activa'); });
        mini.classList.add('an-mini--activa');
      });
    });
  });
}

function initComparadores() {
  document.querySelectorAll('.an-comparador').forEach(function (comparador) {
    var despues = comparador.querySelector('.an-comparador-despues');
    var asa = comparador.querySelector('.an-comparador-asa');
    if (!despues || !asa) return;

    function mover(clienteX) {
      var rect = comparador.getBoundingClientRect();
      var pct = ((clienteX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      despues.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      asa.style.left = pct + '%';
      asa.setAttribute('aria-valuenow', String(Math.round(pct)));
    }

    var arrastrando = false;
    comparador.addEventListener('pointerdown', function (e) { arrastrando = true; mover(e.clientX); });
    window.addEventListener('pointermove', function (e) { if (arrastrando) mover(e.clientX); });
    window.addEventListener('pointerup', function () { arrastrando = false; });
    asa.addEventListener('keydown', function (e) {
      var actual = parseFloat(asa.style.left) || 50;
      if (e.key === 'ArrowLeft') { actual = Math.max(0, actual - 4); }
      else if (e.key === 'ArrowRight') { actual = Math.min(100, actual + 4); }
      else return;
      e.preventDefault();
      despues.style.clipPath = 'inset(0 ' + (100 - actual) + '% 0 0)';
      asa.style.left = actual + '%';
      asa.setAttribute('aria-valuenow', String(Math.round(actual)));
    });
  });
}

function initFaqs() {
  document.querySelectorAll('.an-faq-item').forEach(function (item) {
    var boton = item.querySelector('.an-faq-pregunta');
    var respuesta = item.querySelector('.an-faq-respuesta');
    if (!boton || !respuesta) return;
    boton.addEventListener('click', function () {
      var abierto = item.classList.contains('an-faq-item--abierto');
      item.closest('[data-an-faq]') && item.closest('[data-an-faq]').querySelectorAll('.an-faq-item--abierto').forEach(function (otro) {
        if (otro !== item) {
          otro.classList.remove('an-faq-item--abierto');
          otro.querySelector('.an-faq-respuesta').style.maxHeight = null;
        }
      });
      if (abierto) {
        item.classList.remove('an-faq-item--abierto');
        respuesta.style.maxHeight = null;
      } else {
        item.classList.add('an-faq-item--abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

function initFormulariosProducto() {
  document.querySelectorAll('[data-an-producto-form]').forEach(function (form) {
    var idInput = form.querySelector('input[name="id"]');
    var selects = form.querySelectorAll('[data-an-opcion]');
    var boton = form.querySelector('[data-an-boton-comprar]');
    var precioEl = form.closest('[data-an-columna-compra]') ? form.closest('[data-an-columna-compra]').querySelector('[data-an-precio]') : null;
    var precioComparadoEl = form.closest('[data-an-columna-compra]') ? form.closest('[data-an-columna-compra]').querySelector('[data-an-precio-comparado]') : null;
    var scriptVariantes = form.querySelector('[data-an-variantes-json]');
    if (!selects.length || !scriptVariantes) return;

    var variantes = [];
    try { variantes = JSON.parse(scriptVariantes.textContent); } catch (e) { return; }

    function opcionesSeleccionadas() {
      var vals = [];
      selects.forEach(function (s) { vals.push(s.value); });
      return vals;
    }

    function actualizar() {
      var seleccion = opcionesSeleccionadas();
      var variante = variantes.find(function (v) {
        return v.opciones.length === seleccion.length && v.opciones.every(function (val, i) { return val === seleccion[i]; });
      });
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = variante.precioFormateado;
      if (precioComparadoEl) {
        if (variante.precioComparadoFormateado) {
          precioComparadoEl.textContent = variante.precioComparadoFormateado;
          precioComparadoEl.style.display = '';
        } else {
          precioComparadoEl.style.display = 'none';
        }
      }
      if (boton) {
        boton.disabled = !variante.disponible;
        boton.textContent = variante.disponible ? boton.getAttribute('data-texto-disponible') : boton.getAttribute('data-texto-agotado');
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}
